import { useEffect, type PropsWithChildren } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { uniq } from 'lodash';

import { addToast, removeToast } from '@/components/global/ToastList';

const menuOpenVar = makeVar(false);
const openMenu = () => menuOpenVar(true);
const closeMenu = () => menuOpenVar(false);
const toggleMenu = () => menuOpenVar(!menuOpenVar());

const secondaryMenuOpenVar = makeVar(false);
const openSecondaryMenu = () => secondaryMenuOpenVar(true);
const closeSecondaryMenu = () => secondaryMenuOpenVar(false);
const toggleSecondaryMenu = () => secondaryMenuOpenVar(!menuOpenVar());

const scrollLockVar = makeVar<string[]>([]);
const lockScroll = (id: string) => scrollLockVar(uniq([...scrollLockVar(), id]));
const unlockScroll = (id: string) => scrollLockVar(scrollLockVar().filter((x) => x !== id));

// This component used to set up a Context Provider to wrap the entire application,
// however it is now deprecated in favor of a single hook exposing a handful of
// reactive variables and functions to mutate them.
//
// TODO: Move this to a component with a more descriptive name
export const GlobalProvider = ({ children }: PropsWithChildren) => {
  const scrollLocks = useReactiveVar(scrollLockVar);
  const shouldLock = scrollLocks.length > 0;

  useEffect(() => {
    const fn = shouldLock ? 'add' : 'remove';
    document.body.classList[fn]('overflow-hidden');
  }, [shouldLock]);

  return children;
};

export function useGlobal() {
  const menuOpen = useReactiveVar(menuOpenVar);
  const secondaryMenuOpen = useReactiveVar(secondaryMenuOpenVar);

  return {
    addToast,
    removeToast,

    openMenu,
    closeMenu,
    toggleMenu,

    secondaryMenuOpen,
    openSecondaryMenu,
    closeSecondaryMenu,
    toggleSecondaryMenu,

    menuOpen,
    lockScroll,
    unlockScroll,
  };
}
